import { EnumsUtils } from "@/utils/TaskEnumUtils";
import { UserRole } from "./UserRole";

export enum LAZO_USER_ROLES {
  LAZO_PORTAL_EMPLOYEE = "lazo-portal-employee",
  LAZO_ONE = "lazo-one",
  COMPANY_USER_ADMIN = "lazo-company-user-admin",
  COMPANY_USER_VIEWER = "lazo-company-user-viewer",
  COMPANY_USER_STANDARD = "lazo-company-user-standard",
  COMPANY_CREATE = "lazo-company-create",
  LAZO_PORTAL_USER = "lazo-portal-user",
  LAZO_PORTAL_VIEWER = "lazo-portal-viewer",
  LAZO_PORTAL_STANDARD = "lazo-portal-standard",
  LAZO_PORTAL_KAM = "lazo-portal-kam",
  LAZO_TEAM_ADMIN = "lazo-team-admin",
}

export const COMPANY_ROLES: string[] = [
  LAZO_USER_ROLES.COMPANY_USER_ADMIN,
  LAZO_USER_ROLES.COMPANY_USER_VIEWER,
  LAZO_USER_ROLES.COMPANY_USER_STANDARD,
];

export const PORTAL_ROLES: string[] = [
  LAZO_USER_ROLES.LAZO_PORTAL_USER,
  LAZO_USER_ROLES.LAZO_PORTAL_VIEWER,
  LAZO_USER_ROLES.LAZO_PORTAL_STANDARD,
  LAZO_USER_ROLES.LAZO_PORTAL_KAM,
  LAZO_USER_ROLES.LAZO_TEAM_ADMIN,
];

export const ASSIGNABLE_LAZO_PORTAL_ROLES: string[] = [LAZO_USER_ROLES.LAZO_PORTAL_USER, LAZO_USER_ROLES.LAZO_TEAM_ADMIN];

export const ADMIN_ROLES: string[] = [
  LAZO_USER_ROLES.LAZO_PORTAL_USER,
  LAZO_USER_ROLES.LAZO_TEAM_ADMIN,
  UserRole.ADMIN,
  UserRole.SUPERADMIN,
];

export function mapRolesToString(role: string): string {
  const normalizedRole = role?.trim();

  switch (normalizedRole) {
    case LAZO_USER_ROLES.LAZO_PORTAL_STANDARD:
      return "Standard";
    case LAZO_USER_ROLES.LAZO_PORTAL_VIEWER:
      return "Viewer";
    case LAZO_USER_ROLES.LAZO_PORTAL_KAM:
      return "KAM";
    case LAZO_USER_ROLES.LAZO_PORTAL_USER:
    case "LAZO_USER":
      return "Lazo User";
    case LAZO_USER_ROLES.LAZO_TEAM_ADMIN:
    case "LAZO_TEAM_ADMIN":
      return "Lazo Team Admin";
    default:
      return EnumsUtils.parseEnumToRender(role);
  }
}
